// Prepends
// -------------------------------------------
// @codekit-prepend "../../../release/bower_components/sprockets-modernizr/modernizr.js";
// @codekit-prepend "../../../release/bower_components/jquery/dist/jquery.js";
// @codekit-prepend "../../../release/bower_components/magnific-popup/dist/jquery.magnific-popup.js";
// @codekit-prepend "../../../release/bower_components/bootstrap/dist/js/bootstrap.js";
// @codekit-prepend "../../../release/bower_components/elementQuery/elementQuery.js";
// @codekit-prepend "../../../release/bower_components/jquery-validation/dist/jquery.validate.js";
// @codekit-prepend "../../../bower_components/select2/dist/js/select2.js";
// @codekit-prepend "myCapitechApi.js";
// @codekit-append "../localization.js";
// @codekit-append "../browserValidation.js";
// @codekit-append "../localStorage.js";
// @codekit-append "../cookies.js";

// Appends
// --------------------------------------------
// @codekit-append "data-duty-wish-form.js";
// @codekit-append "index.js";
// @codekit-append "page.js";
// @codekit-append "navigation.js";
// @codekit-append "component-permissions.js";
// @codekit-append "component-login.js";
// @codekit-append "component-unread-messages.js";
// @codekit-append "component-navigation.js";
// @codekit-append "component-calendar.js";
// @codekit-append "component-settings.js";
// @codekit-append "component-report.js";
// @codekit-append "component-vacation-balance.js";
// @codekit-append "component-flexitime-balance.js";
// @codekit-append "component-incoming-messages.js";
// @codekit-append "component-outgoing-messages.js";
// @codekit-append "component-outgoing-messages-form.js";
// @codekit-append "component-help.js";
// @codekit-append "component-absence-form.js";
// @codekit-append "component-absence-requests.js";
// @codekit-append "component-flexitime.js";
// @codekit-append "component-vacation.js";
// @codekit-append "component-employee-information.js";
// @codekit-append "component-change-password.js";
// @codekit-append "component-filter-dutywish-department-dutytype.js";
// @codekit-append "component-duty-wish-period.js";

var _windowWidth = $(window).width();
var _windowHeight = $(window).height();
var _logoOffset = 0;
var _appSettingsObj = getLocalStorage('myCapitechSettings');
var _api;
var _username;
var _clients;
var _loaderArray = [];
var _myCapitechIdentifier = '{gulp-my-capitech-identifier}';
var _myCapitechVersion = '{gulp-my-capitech-version}';
var _applicationInterval;
var _lastActivity = new Date();

$(document).ready(function() {
	$(window).scroll(function() {
		if (_windowWidth <= 799) {
			$('.mobile-nav-wrapper').css({
				height: 0,
				opacity: 0
			});
			$('.mobile-menu').removeClass('open');
		}
	});
	
	$(window).resize(function() {
		_windowWidth = $(window).width();
		_windowHeight = $(window).height();
		// _windowWidth
		if (_windowWidth <= 799) {
			$('.mobile-nav-wrapper').css({
				height: 0,
				opacity: 0
			});
			$('.mobile-menu').removeClass('open');
		} else {
			$('.mobile-nav-wrapper').css({
				height: 'auto',
				opacity: 1
			});
		}
	});
	
	// Use FastClick together with knockout
	window.ko.bindingHandlers.fastclick = {
		init: function(element, valueAccessor) {
			$(element).off('click').on('click', function() {
				var $this = $(this);
				$this.attr('disabled','disabled').addClass('ct-disable-click');
				setTimeout(function() {
					$this.removeAttr('disabled').removeClass('ct-disable-click');
				}, 1000);
			});
			if (!$(element).hasClass('ct-disable-click')) {
				FastClick.attach(element);
				return ko.bindingHandlers.click.init.apply(this, arguments);
			}
		}
	};
	
	window.ko.bindingHandlers.preventBubble = {
		init: function(element, valueAccessor) {
			var eventName = ko.utils.unwrapObservable(valueAccessor());
			ko.utils.registerEventHandler(element, eventName, function(event) {
				event.cancelBubble = true;
				if (event.stopPropagation) {
					event.stopPropagation();
				}
			});
		}
	};

	var userSettings = getLocalStorage("myCapitechUserSettings");
	var inputTimeType = userSettings && userSettings.useNativeTimeInput && userSettings.useNativeTimeInput === 'false' ? 'text' : 'time';
	window.ko.components.register('time-edit', {
		viewModel: function(params) {
			self = this;
			this.time = params.time;
			this.id = params.id ? params.id : "id" + new Date().getTime() + "-" + (Math.floor(Math.random() * 10000));
			this.required = params.required !== undefined ? params.required : false;
			this.enabled = params.enabled !== undefined ? params.enabled : true;
			
			this.validateTimeValue = function(_this, evt) {
				var hourAsString = _this.time();

				if (!hourAsString || hourAsString.length === 0) {
					// Info: The native input time elements can contain a value that the user can se (UI), but that will not be registered (eg: 18:__),
					// we need to reset the time component if the value is an empty string to be sure that the value will be cleared from the UI.
					_this.time("00:00");
					_this.time("");
					return false;
				}

				if (hourAsString.indexOf(":") === -1) {
					if (hourAsString.length === 1) {
						hourAsString = "0" + hourAsString + "00";
					} else if (hourAsString.length === 2) {
						hourAsString = hourAsString + "00";
					} else if (hourAsString.length === 3) {
						hourAsString = "0" + hourAsString;
					}
					var parts = hourAsString.split("");
					parts.splice(2, 0, ":");
					hourAsString = parts.join("");
				}

				if (hourAsString === "24:00") {
					hourAsString = "00:00";
					_this.time("00:00");
				}

				var hoursParts = hourAsString.split(':');
				var hours = isNaN(parseInt(hoursParts[0])) ? "0" : parseInt(hoursParts[0]);
				var minutes = isNaN(parseInt(hoursParts[1])) ? "0" : parseInt(hoursParts[1]);
				var isValid = true;

				if (isNaN(parseInt(hoursParts[0])) || isNaN(parseInt(hoursParts[1]))) {
					isValid = false;
				} else {
					if (hours < 0 || hours > 23) {
						isValid = false;
					}
					
					if (isValid === true && (minutes < 0 || minutes > 59)) {
						isValid = false;
					}
				}
			
				if (isValid === false) {
					_this.time("");
				} else {
					_this.time(addTimePadding(hours, minutes));
				}
			}

			function addTimePadding(hours, minutes) {
				var hoursAsString = hours.toString();
				var minutesAsString = minutes.toString();
				if (hoursAsString.length === 1) {
					hoursAsString = "0" + hoursAsString;
				}
				if (minutesAsString.length === 1) {
					minutesAsString = "0" + minutesAsString;
				}
				return hoursAsString + ":" + minutesAsString;
			}
		},
		template: '<input type="' + inputTimeType + '" class="form-control" step="300" placeholder="XX:XX" pattern="[0-9]{2}:[0-9]{2}" data-bind="value: time, enable: enabled, attr: {id: id, required: required}, event:{blur: validateTimeValue}" />'
	});

	
	// Workaround to get select2 working together with magnific popup

	// For Select2 v.4.x
	$.magnificPopup.instance._onFocusIn = function(e) {
		// Do nothing if target element is select2 input
		if($(e.target).hasClass('select2-search__field')) {
			return true;
		}
		// Else call parent method
		$.magnificPopup.proto._onFocusIn.call(this,e);
	}
	
	// For Select2 v.3.5.x
	// $.magnificPopup.instance._onFocusIn = function(e) {
	// 	// Do nothing if target element is select2 input
	// 	if( $(e.target).hasClass('select2-input') ) {
	// 		return true;
	// 	}
	// 	// Else call parent method
	// 	$.magnificPopup.proto._onFocusIn.call(this,e);
	// };

	// Custom alias for input mask
	Inputmask.extendAliases({
		'capitechHourAndMinutes': {
			autoUnmask: false,
			mask: "99:99",
			placeholder: 'XX:XX',
			clearIncomplete: true,
			insertMode: false,
			oncomplete: function(e) {
				var hourAsString = $(e.currentTarget).val();
				if (hourAsString === "24:00") {
					hourAsString = "00:00";
					$(e.currentTarget).val("00:00");
				}
				var hoursParts = hourAsString.split(':');
				var hours = parseInt(hoursParts[0]);
				var minutes = parseInt(hoursParts[1]);
				var isValid = true;

				if (hours < 0 || hours > 23) {
					isValid = false;
				}
				if (isValid === true && (minutes < 0 || minutes > 59)) {
					isValid = false;
				}
				
				if (isValid === false) {
					$(e.currentTarget).val("");
				}
			}
		}
	});
	
	// Validate browser / client
	validateClient();
	
	// Init application settings
	capitechInitSettings();
	
	// Init API
	capitechInitAPI();
	
	// Fallbacks / polyfills
	if (Modernizr.inputtypes.date === false) {
		$('.ct-date-input').datepicker({
			format: "yyyy-mm-dd",
			weekStart: moment().startOf('week').format('E'),
			todayBtn: "linked",
			language: _appSettingsObj.languageShort,
			todayHighlight: true,
			autoclose: true
		});
	}
	
	// Fastclick
	FastClick.attach(document.body);
	
	// Run applicationLoop immediately and start the application loop interval
	applicationLoop();
	_applicationInterval = setInterval(function() {applicationLoop()}, 10000);

	if($('body.index').length > 0) {
		resetLocalStorage();
	} else {
		loadExternalAssets();
	}
	
	// Get translations
	getTranslationFromLocalStorage();
	
	// Initialize components
	initializeComponents();
	// Translate
	translateGUI();
	
	$('.logout').click(function(evt) {
		loaderIndicator(true);
		evt.preventDefault();
		logoutUser();
	});
});

function logoutUser() {
	var loginType = getLocalStorage("loginType");
	var simployerSignOutUrl = getLocalStorage("signOutUrl");
	if (loginType !== "simployerSaam") {
		_api.signOut_POST(
			// success
			function (data, textStatus, jqXHR) {
			},
			// error
			function (jqXHR, textStatus, errorThrown) {
			},
			// params
			getCookie("ACCESSTOKEN_COOKIE_NAME")
		);
		eraseCookie(REFRESHTOKEN_COOKIE_NAME);
		eraseCookie(ACCESSTOKEN_COOKIE_NAME);
		resetLocalStorage();
		window.location.href = 'index.htm?v={gulp-my-capitech-version}';
	} else {
		window.location.replace(simployerSignOutUrl);
	}
}

function capitechInitSettings() {
	var userLang = getUserLanguage();
	if(_appSettingsObj === undefined || _appSettingsObj === null || _appSettingsObj === "undefined" || typeof _appSettingsObj !== "object") {
		_appSettingsObj = {
			apiURL: getProjectURL(window.location.pathname),
			language: userLang
		}
	}
	if (_appSettingsObj.language === undefined || _appSettingsObj.language.length === 0) {
		// If language is empty, set to browser language
		_appSettingsObj.language = userLang;
	}
	if (getURLVariable('debug') !== undefined) {
		_appSettingsObj.bDebug = getURLVariable('debug');
	}
	_appSettingsObj.languageShort = getShortLanguageCode(_appSettingsObj.language);
	
	if (_appSettingsObj.languageShort == "no") {
		moment.updateLocale("nb", { weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_') });
	}

	setLocalStorage('myCapitechSettings', _appSettingsObj);
	moment.locale(_appSettingsObj.language);
}

function getDefaultClientID() {
	var clientId = "";
	var clientIdFromCookie = getCookie(CLIENTID_COOKIE_NAME);
	
	if (clientIdFromCookie && clientIdFromCookie.length > 0) {
		clientId = clientIdFromCookie;
	}
	
	return clientId;
}

function getUserLanguage(languageString) {
	var language = languageString || navigator.language || navigator.userLanguage;
	
	if ($.inArray(language.split('-')[0], ['nb','nn','nb-NO','nn-NO', 'norsk', 'norwegian']) > -1) {
		language = 'nb-NO';
	} else {
		language = 'en-EN';
	}
	return language;
}

function getShortLanguageCode(languageCode) {
	return languageCode.split('-').pop().toLowerCase();
}

function getTranslationFromLocalStorage() {
	// If localStorage not is set we need to set it
	if (!getLocalStorage('myCapitechLanguages') || window.location.pathname.indexOf('.htm') === -1 || window.location.pathname.indexOf('index.htm') > 0) {
		setLocalStorage('myCapitechLanguages', languages);
	}
	translateDocumentTitle();
	languages[_appSettingsObj.language] = getLocalStorage('myCapitechLanguages')[_appSettingsObj.language];
}

function translateDocumentTitle() {
	document.title = getResource('app.name', 'My Capitech', 'title');
}

function getProjectURL(path) {
	var aPath = path.split('/');
	return window.location.protocol + '//' + window.location.host + aPath.slice(0, aPath.length - 3).join('/') + '/';
}

function capitechInitAPI() {
	_api = new Capitech.Api.WebtidApi(_appSettingsObj.apiURL);
}

function handleServerErrorMessage(message) {
	var retMessage = '';
	if (message.substring(0, 17) == 'LocalizationKey: ') {
		localizationKey = message.slice(17);
		retMessage = getResource(localizationKey);
		if (localizationKey === "Errors_Authorization_401" || localizationKey === "Errors_InvalidAccessToken") {
			sweetAlert({
				title: getResource('app.informationTitle', '401 Unauthorized'),
				text: getResource(retMessage, 'User is not authorized, you need to log in.'),
				type: "error",
				closeOnConfirm: true
			}, function() {
				logoutUser();
			});
			throw "401 Unauthorized!";
		} else {
			return retMessage;
		}
	} else {
		return message;
	}
}

function applicationLoop() {
	var accessTokenExpire;
	var nowDateTime = moment();
	var millisecondsToLogout;
	// Run on all pages except the index page
	if($('body.index').length === 0) {
		accessTokenExpire = moment(getLocalStorage('myCapitechAccessTokenExpires'));
		millisecondsToLogout = accessTokenExpire.diff(nowDateTime);
		
		// If accessToken has expired, log out
		if (!millisecondsToLogout || millisecondsToLogout <= 0) {
			window.location.href = 'index.htm?v={gulp-my-capitech-version}';
		}
		// If accessToken is about to expire, refresh if eq or less than 1 minutes / 60000 ms
		if (millisecondsToLogout <= 60000) {
			refreshAccessToken();
		}
	}

	function checkForNewVersion(versionNumber) {
		var currentServerVersion = getLocalStorage("myCapitechServerVersion");
		var bDisplayUpdateMessage = false;
		var bMajorUpdate = false;

		if (versionNumber && currentServerVersion && currentServerVersion.length > 0 && versionNumber !== currentServerVersion) {
			setLocalStorage("myCapitechServerVersion", versionNumber);
			bDisplayUpdateMessage = true;
			if ($('body.index').length === 0 && versionNumber.split(".")[0] - currentServerVersion.split(".")[0] > 0) {
				bMajorUpdate = true;
			}
		}

		if (!currentServerVersion || currentServerVersion.length === 0) {
			setLocalStorage("myCapitechServerVersion", versionNumber);
		}

		if (bDisplayUpdateMessage) {
			if (bMajorUpdate) {
				// Log out user
				sweetAlert({
					title: '',
					text: getResource("app.newVersionInfo", "My Capitech has just been updated. Click update to log out and get access to the new version. If you don't want to update now, you can log out to get the newest version later."),
					showCancelButton: true,
					confirmButtonText: getResource('app.update', 'Update'),
					cancelButtonText: getResource('app.cancel', 'Cancel')
				}, function(isConfirm) {
					if(isConfirm) {
						window.location.href = "./";
					}
				});
			} else {
				sweetAlert({
					title: '',
					text: getResource("app.newVersionInfo", "My Capitech has just been updated. Click update to get the updated version. If you don't want to update now, you can refresh the page later."),
					showCancelButton: true,
					confirmButtonText: getResource('app.reload', 'Update'),
					cancelButtonText: getResource('app.cancel', 'Cancel')
				}, function(isConfirm) {
					if(isConfirm) {
						location.reload();
					}
				});
			}
		}
	}

	// getServerVersion(checkForNewVersion);
}

function loadExternalAssets() {
	loadTheme();
	var simployerCSSURL = getLocalStorage("simployerGlobalMenuCssUrl");
	loadCSS(simployerCSSURL, "simployer-global-menu-css");
	
	if (getLocalStorage("loginType") === "simployerSaam") {
		var simployerJSURL = getLocalStorage("simployerGlobalMenuJsUrl");
		simployerJSURL = simployerJSURL.replace("{SCI}", getCookie(SIMPLOYER_SCI_COOKIE_NAME));
		simployerJSURL = simployerJSURL.replace("{APPID}", getCookie(SIMPLOYER_APPID_COOKIE_NAME));
		simployerJSURL = simployerJSURL.replace("{CULTURECODE}", _appSettingsObj.language);

		loadJS(simployerJSURL);
	}
}

function loadTheme() {
	var themeCSSURL = "./css/style-" + getLocalStorage("myCapitechTheme") + ".css?v={gulp-my-capitech-version}";
	loadCSS(
		themeCSSURL,
		"style-theme-" + getLocalStorage("simployerGlobalMenuCssUrl"),
		function() {
			// Add
			setTimeout(function() {
				$("#stylesheet-main").remove()
			}, 250);
		}
	);
}

function getServerVersion(callback) {
	var success = function success(data, textStatus, jqXHR) {
		if (data.success && data.content && data.content.length > 0) {
			callback(data.content[0]);
		} else {
			callback(undefined);
		}
	};
	var error = function error(jqXHR, textStatus, errorThrown) {
		callback(undefined);
	};
	_api.getServerVersion_GET(success, error);
}

function refreshAccessToken() {
	var refreshToken = getCookie(REFRESHTOKEN_COOKIE_NAME);
	var success = function success(data, textStatus, jqXHR) {
		if (data.success == true && data.content.length === 1) {
			persistTokens(data.content[0]);
			setLocalStorage('myCapitechAccessTokenExpires', data.content[0].accessTokenExpires);
		} else {
			loaderIndicator(false);
			sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
		}
	};
	var error = function error(jqXHR, textStatus, errorThrown) {
		loaderIndicator(false);
		sweetAlert("Error", errorThrown, "error");
	};
	_api.refreshAuthorization_POST(success, error, refreshToken);
}

// Helpers
// ---------------------------------------------------------
function validateClient() {
	bSupportLocalStorage();
}

function initializeComponents($parentElm) {
	if(typeof($parentElm)==='undefined') $parentElm = $('body');
	$parentElm.find('*[data-component]').each(function(index, obj) {
		// console.log('-------------- [data-component: ' + $(obj).data('component') + '] ------------------');
		initializeComponent(this);
	});
}

function initializeComponent(obj) {
	var $obj = $(obj);
	try {
		$obj[$obj.data('component')]();
		// console.log($obj.data('component'));
		// console.log($obj);
		// console.log('-----------initializeComponent (finished)--------------');
	} catch (err) {
		// console.log('-----------initializeComponent (finished with error) --------------');
		// console.log(err);
	}
}

function getURLVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if(pair[0] == variable){return pair[1];}
	}
	return undefined;
}

function updateURLParameter(url, queryParam, queryParamValue) {
	var TheAnchor = null;
	var newAdditionalURL = "";
	var tempArray = url.split("?");
	var baseURL = tempArray[0];
	var additionalURL = tempArray[1];
	var temp = "";
  
	if (additionalURL) {
	  var tmpAnchor = additionalURL.split("#");
	  var TheParams = tmpAnchor[0];
	  TheAnchor = tmpAnchor[1];
	  if (TheAnchor) additionalURL = TheParams;
  
	  tempArray = additionalURL.split("&");
  
	  for (var i = 0; i < tempArray.length; i++) {
		if (tempArray[i].split("=")[0] != queryParam) {
		  newAdditionalURL += temp + tempArray[i];
		  temp = "&";
		}
	  }
	} else {
	  var tmpAnchor = baseURL.split("#");
	  var TheParams = tmpAnchor[0];
	  TheAnchor = tmpAnchor[1];
  
	  if (TheParams) baseURL = TheParams;
	}
  
	if (TheAnchor) queryParamValue += "#" + TheAnchor;
  
	var rows_txt = temp + "" + queryParam + "=" + queryParamValue;
	return baseURL + "?" + newAdditionalURL + rows_txt;
  }
  

function findObjectInArray(array, key, keyValue) {
	var foundObj = $.grep(array, function(item) {
		return (item[key] == keyValue);
	});
	return foundObj[0];
};

function isInArray(value, array) {
	return array.indexOf(value) > -1;
}

function loaderIndicator(bShow) {
	if(typeof(bShow) === 'undefined') bShow = true;
	
	var $body = $('body');
	
	if (bShow) {
		_loaderArray.push(new Date);
	} else {
		_loaderArray.shift();
	}
	
	if (_loaderArray.length === 1) {
		$body.toggleClass("loading", true);
	}
	if (_loaderArray.length === 0) {
		setTimeout(function () {
			$body.toggleClass("loading", false);
		}, 250);
	}
}

function displayAjaxErrorAlert(jqXHR, bShowCancel, cancelCallback) {
	if (typeof(jqXHR)==='undefined') jqXHR = {statusText: "error", responseJSON:{displayErrorMessage:"", serverErrorMessage:""}};
	if (typeof(bShowCancel)==='undefined') bShowCancel = false;
	if (typeof(cancelCallback)==='undefined') cancelCallback = function() {};
	
	var title = getResource('app.systemErrorTitle')
	var text = getResource('app.systemErrorMsg');
	var type = 'error';
	
	// Hide loader
	loaderIndicator(false);
	
	if (jqXHR.statusText == 'timeout') {
		title = getResource('app.timeoutErrorTitle', 'License information');
		text = getResource('app.timeoutErrorMsg', 'Invalid system license.');
		type = 'warning';
	} else if(jqXHR.hasOwnProperty('responseJSON')){
		if (jqXHR.responseJSON.displayErrorMessage == 'Access denied.' && jqXHR.responseJSON.serverErrorMessage ==  'Invalid system license.') {
			title = getResource('app.licenseTitle');
			text = getResource('app.licenseInvalidText');
			type = 'warning';
		}
	}
	
	sweetAlert({
		title: title,
		text: text,
		type: type,
		showCancelButton: bShowCancel,
		confirmButtonText: getResource('app.tryAgainBtn'),
		cancelButtonText: getResource('app.settingsBtn')
	}, function(isConfirm) {
		if(isConfirm) {
			setTimeout(function () {
				location.reload();
			}, 750);
			
		} else {
			$('.ct-settings').trigger('click');
		}
	});
}

function loweCaseObjectKeys(obj) {
	var keys = Object.keys(obj);
	var newObj = {};
	var n = keys.length;
	while (n--) {
		var key = keys[n];
		newObj[key.toLowerCase()] = obj[key];
	}
	return newObj;
}

function validateEmailAddress(email) {
	try {
		var emailCheck = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
		return emailCheck.test(email);
	} catch (error) {
		return false;
	}
}

function downloadLanguageBundle() {
	var data = JSON.stringify(getLocalStorage("myCapitechLanguages"));
	var filename = "my-capitech-language-bundle.json";
	var type = "application/json";
	var file = new Blob([data], {type: type});
	if (window.navigator.msSaveOrOpenBlob) // IE10+
		window.navigator.msSaveOrOpenBlob(file, filename);
	else { // Others
		var a = document.createElement("a"),
				url = URL.createObjectURL(file);
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		setTimeout(function() {
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);  
		}, 0); 
	}
}

function loadJS(url, callbackFn) {
	var scriptElement = document.createElement('script');
	scriptElement.src = url;

	if (callbackFn) {
		scriptElement.onload = callbackFn;
		scriptElement.onreadystatechange = callbackFn;
	}

	document.body.appendChild(scriptElement);
};

function loadCSS(url, id, callbackFn){
	var styleElement = document.createElement("link");

	styleElement.setAttribute("rel", "stylesheet");
	styleElement.setAttribute("type", "text/css");
	styleElement.setAttribute("href", url);

	if (id) {
		styleElement.setAttribute("id", id);
	}

	if (callbackFn) {
		styleElement.onload = callbackFn;
		styleElement.onreadystatechange = callbackFn;
	}

	document.getElementsByTagName("head")[0].appendChild(styleElement);
}

function toggleClass(idToActivate, activeClassName) {
	$("#" + idToActivate).toggleClass(activeClassName);
}